import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Store } from 'lucide-react';
import { useAuth } from '../AuthContext';

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      const me = await login(email, password);
      const t = me.tenant;
      if (me.role === 'partner') {
        navigate('/partner');
      } else if (me.role === 'tenant_admin' && t && !t.published && !(t.settings?.onboarding?.completed)) {
        navigate('/onboarding/wizard');
      } else {
        navigate('/admin');
      }
    } catch (e2) {
      setErr(e2.response?.data?.detail || 'Accesso non riuscito');
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-paelbi-bg px-4">
      <div className="w-full max-w-sm rounded-2xl border border-paelbi-line bg-white p-8 shadow-card">
        <div className="mb-6 flex flex-col items-center">
          <Store size={30} className="text-paelbi-brown" />
          <h1 className="mt-3 font-display text-2xl text-paelbi-ink">Domira Admin</h1>
          <p className="text-sm text-paelbi-ink/60">Accedi alla console di gestione</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full rounded-lg border border-paelbi-line bg-white px-3 py-2 text-sm outline-none focus:border-paelbi-brown" />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-paelbi-ink/80">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full rounded-lg border border-paelbi-line bg-white px-3 py-2 text-sm outline-none focus:border-paelbi-brown" />
          </div>
          {err && <p className="text-sm text-red-600">{err}</p>}
          <button disabled={busy} type="submit"
            className="h-11 w-full rounded-btn bg-paelbi-brown font-semibold text-white transition-colors hover:bg-paelbi-brown-dark disabled:opacity-60">
            {busy ? 'Accesso...' : 'Accedi'}
          </button>
        </form>
        <p className="mt-6 text-center text-sm text-paelbi-ink/60">
          Non hai una struttura? <a href="/onboarding" className="font-semibold text-paelbi-brown" data-testid="login-register-link">Registrala gratis</a>
        </p>
      </div>
    </div>
  );
}

export default Login;
